_collow.components.AdminControlUsers = class AdminControlUsers extends (
  _collow.components.Base
) {
  root;
  elements;
  params;

  fileInput = null;
  selectedUsersID = [];
  selectedUsersEmails = [];
  users = [];
  groupList = [];

  uploadCounter = 1;

  lastOpenedUserKebab;
  whitelabelFeatureAccess;

  massUserDeletionOriginalText;

  trackerTable = {
    name: null,
    email: null,
    groups: null,
    status: null,
  }

  groupFilterDict = [];
  statusFilterDict = [];
  roleFilterDict = [];
  visibleGroups = [];
  visibleRoles = [];
  visibleStatuses = [];
  filteredUsers = [];

  searchQuery = null;

  searchQueryActive = false;
  filterActive = false
  sorterActive = false;

  loggedAdminAccount = JSON.parse(window.localStorage.progressJson).email
  selfAdminCheck = null

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    window.addEventListener("_collow.current-user", () => this.handleWhitelabelFeaturesAccess());

    this.handleWhitelabelFeaturesAccess();

    // Disable import and add users button until all users are loaded
    window.addEventListener('load', () => {
      this.getUsers().then(() => {
        this.enableButtons();
      });
    });

    this.getGroups()
    this.getStatus()
    this.getRoles()

    this.listen(document, "_collow.overlay.clicked", this.deselectAll);
    this.listen(elements.selectAll, "click", this.checkAll)
    this.listen(elements.importFile, "click", this.fileCounter)
    this.listen(elements.importFile, "change", this.fileInputChange)
    this.listen(elements.import, "click", this.onClickBulkUserImportPopup);
    this.listen(elements.dragDropField, "drop", this.dropHandler);
    this.listen(elements.confirmImport, "click", this.onClickBulkUserImportButton);
    this.listen(elements.downloadFailed, "click", this.onClickDownloadFailedButton);
    this.listen(elements.cancelImportA, "click", this.onClickCancelImportButton);
    this.listen(elements.cancelImportB, "click", this.onClickCancelImportButton);
    this.listen(elements.confirmImportResult, "click", this.onClickAddOkImportButton);
    this.listen(elements.addOkImport, "click", this.onClickAddOkImportButton);
    this.listen(elements.closeSuccessfulImport, "click", this.onClickCancelImportButton);

    this.listen(elements.delete, "click", (event) => this.onClickDeleteUserButton(event));
    this.listen(elements.edit, "click", this.onClickEditUserButton);
    this.listen(elements.userDeactivate, "click", (event) => this.onClickDeactivateButton(event));
    this.listen(elements.userReactivate, "click", (event) => this.onClickReactivateButton(event));
    this.listen(elements.userRecover, "click", (event) => this.onClickRecoverButton(event));
    this.listen(elements.kebabMulti, "click", (event) => this.onClickMultipleUserKebab(event));
    this.listen(elements.userSearch, "input", (event) => this.onSearch(event.target.value));
    this.listen(elements.addUser, "click", (event) => this.onClickAddUserButton(event));

    this.listen(elements.nameOrder, "click", () => this.tableSort('name'));
    this.listen(elements.emailOrder, "click", () => this.tableSort('email'));
    this.listen(elements.groupsOrder, "click", () => this.tableSort('groups'));
    this.listen(elements.statusOrder, "click", () => this.tableSort('status'));
    this.listen(elements.roleOrder, "click", () => this.tableSort('role'));

    this.listen(elements.groupFilter, "click", this.showGroupFilterMenu)
    this.listen(elements.statusFilter, "click", this.showStatusFilterMenu);
    this.listen(elements.roleFilter, "click", this.showRoleFilterMenu);
    this.listen(elements.groupSearch, "input", (event) => this.onFilterSearch('group', event.target.value));
    this.listen(elements.statusSearch, "input", (event) => this.onFilterSearch('status', event.target.value));

    // Check for flag that user limit of 80% or 100% has been exceeded
    this.checkUserLimitExceeded();

    this.handlePopupsClose();
  }

  //original text of the mass user deletion button, stored to reset the text after the countdown

  USER_STATUS_ACTIVE = 1;
  USER_STATUS_NOT_ACTIVE = false
  USER_STATUS_DEACTIVATED = 3;
  USER_STATUS_DELETED = 4;

  handleWhitelabelFeaturesAccess = async () => {
    this.whitelabelFeatureAccess = JSON.parse(window.localStorage.getItem('whitelabelFeatures'));

    if (!this.whitelabelFeatureAccess) return;
    this.maxUsers = JSON.parse(window.localStorage.getItem('whitelabelFeatures')).max_users;
    this.setHidden(this.elements.import, this.whitelabelFeatureAccess.has_bulk_import == false);

  }


  /** get all users and renders them in container*/
  getUsers = async () => {
    this.selectedUsersID = [] // clear list
    this.users = [] // clear list
    this.selectedUsersEmails = []

    const page = window.document.body
    page.classList.add("loading")

    const response = await fetch(this.params.path + "/admin/user", {
      method: "get",
      headers: {
        Authorization: window.localStorage.getItem("token"),
      },
    });
    if (!response.ok) return;

    this.users = await response.json();
    this.users.forEach((user) => {
      if (user.groups.length === 0) {
        user.groups = ['groupLess']
      }
    })
    this.getUserCount();
    (this.filterActive || this.searchQueryActive || this.sorterActive) ? this.facilitateSFS() : this.displayUserTable(this.users);
    page.classList.remove("loading")
  }

  /**
   * Get the count of users from the API
   * This is called instead of checking the length of the users array because
   * the criteria we use for counting may not be the same as the criteria for displaying users
   * 
   * e.g: Users marked for deletion are not counted in the user count
   * however, they might be displayed in the user table in the future
   */
  getUserCount = async () => {
    const response = await fetch(this.params.path + "/admin/user/count", {
      method: "get",
      headers: {
        Authorization: window.localStorage.getItem("token"),
      },
    });
    if (!response.ok) {
      this.elements.amountUsers.textContent = `0/${this.maxUsers}`;
      this.currentUsers = 0;
      return;
    };

    const currentUsers = await response.json();
    this.elements.amountUsers.textContent = `${currentUsers}/${this.maxUsers}`;
    this.currentUsers = currentUsers;
  }

  displayUserTable = (users) => {
    const tbody = this.elements.tbody

    tbody.textContent = '';

    users.forEach((user, index) => {
      const newRow = this.getUserRow(user, index);
      tbody.appendChild(newRow);
    });
  }

  getUserRow = (user, index) => {
    const fullname = () => {
      const firstname = user.firstname || '';
      const prefix = user.prefix || '';
      const lastname = user.lastname || '';


      return `${firstname} ${prefix} ${lastname}`.trim();
    };


    const newRow = document.createElement('tr');
    newRow.dataset.id = user.user_id;
    newRow.dataset.email = user.email || '';

    const checkboxCell = document.createElement('td');
    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkboxCell.appendChild(checkbox);

    const nameCell = document.createElement('td');
    nameCell.textContent = fullname(user) || ''
    nameCell.classList.add("notranslate")


    const emailCell = document.createElement('td');
    emailCell.textContent = user.email || '';
    emailCell.classList.add("notranslate")

    const groupsCell = document.createElement('td');
    groupsCell.classList.add("notranslate")

    const groupsCellDiv = document.createElement('div');
    groupsCellDiv.classList.add("userGroups");
    groupsCell.appendChild(groupsCellDiv);
    groupsCellDiv.style.whiteSpace = 'nowrap';

    if (!user.groups.includes('groupLess')) {
      for (let i = 0; i < user.groups.length; i++) {
        const groupPerCell = document.createElement('groupLabel');
        groupPerCell.textContent = user.groups[i];
        groupsCellDiv.append(groupPerCell)
      }
    }

    const roleCell = document.createElement('td');
    if (user.role === 2) {
      roleCell.textContent = this.params.adminrole
    }
    else {
      roleCell.textContent = this.params.userrole
    }

    const userStatusCell = document.createElement('td');
    let deletedStatus = null;
    let timeTillDelete = null;
    const todayDate = new Date()
    if (user.account_active == false) {
      userStatusCell.style.color = '#EC8717';
      userStatusCell.textContent = '•  ' + this.params.invitedstatus;
    } else if (user.status == 2) {
      userStatusCell.style.color = '#FF0000';
      userStatusCell.textContent = '• Deleted'; // this one should not be seen - this is an account that was already fully deleted
    } else if (user.status == 3) {
      userStatusCell.style.color = '#707070';
      userStatusCell.textContent = '•  ' + this.params.deactivatedstatus;
    } else if (user.status == 4) {
      const deleteDate = new Date(user.deletion_request_date)
      const timeDelta = Math.round((deleteDate.getTime() - todayDate.getTime()) / 86400000)
      deletedStatus = document.createElement('p')
      deletedStatus.style.color = '#FF0000';
      deletedStatus.textContent = '•  ' + this.params.deletedstatus;
      deletedStatus.style.fontSize = '14.08px'
      timeTillDelete = document.createElement('p')
      timeTillDelete.style.color = '#707070';
      timeTillDelete.textContent = this.params.pretimetilldelete + timeDelta + this.params.posttimetilldelete
      timeTillDelete.style.fontSize = '12.08px'
      timeTillDelete.style.textAlign = 'center'
    } else if (user.status == 1) {
      userStatusCell.style.color = '#24AD0C';
      userStatusCell.textContent = '•  ' + this.params.activestatus;
    }

    const kebabCell = document.createElement('td')
    const kebabOptionButton = document.createElement('button')
    kebabOptionButton.classList.add('kebab-button')
    const kebabOptionButtonIcon = document.createElement('i');
    kebabOptionButtonIcon.classList.add('fa-solid', 'fa-ellipsis-vertical', 'kebab-menu');
    kebabOptionButton.appendChild(kebabOptionButtonIcon);
    kebabCell.appendChild(kebabOptionButton)

    newRow.appendChild(checkboxCell);
    newRow.appendChild(nameCell);
    newRow.appendChild(emailCell);
    newRow.appendChild(groupsCell);
    newRow.appendChild(roleCell)
    newRow.appendChild(userStatusCell);
    try {
      userStatusCell.appendChild(deletedStatus);
      userStatusCell.appendChild(timeTillDelete);
    }
    catch { }
    newRow.appendChild(kebabCell);

    checkboxCell.addEventListener('click', (event) => {
      checkbox.click();
    });

    checkbox.addEventListener('click', (event) => {
      event.stopPropagation();
      const userId = newRow.dataset.id;
      const email = newRow.dataset.email;
      const isSelected = event.target.checked;

      if (isSelected) {
        newRow.classList.add("active");
        this.selectedUsersID.push(userId);
        this.selectedUsersEmails.push(email);
      } else {
        newRow.classList.remove("active");
        this.selectedUsersID = this.selectedUsersID.filter(listId => listId !== userId);
        this.selectedUsersEmails = this.selectedUsersEmails.filter(listId => listId !== email);
      }
    });

    kebabOptionButton.addEventListener("click", (event) => this.onClickUserKebab(event))

    if (user.status === 3) {
      this.setVague(newRow);
    }

    return newRow;
  };

  setVague = (tr, vague = true) => {
    if (vague) {
      if (!tr.classList.contains("vague-effect")) {
        tr.classList.add("vague-effect");
        const kebabCell = tr.querySelector("td:last-child");
        kebabCell.style.opacity = 1; //do not set the vague effect on the kebab menu
      }
    } else {
      if (tr.classList.contains("vague-effect")) {
        tr.classList.remove("vague-effect");
      }
    }
  }

  checkAll = () => {
    const selectAllCheckbox = this.elements.selectAll;
    const isSelected = selectAllCheckbox.checked;

    const tableRows = this.elements.tbody.children;
    for (let i = 0; i < tableRows.length; i++) {
      const currentRow = tableRows[i];
      const checkbox = currentRow.querySelector('input[type="checkbox"]');

      if (checkbox) {
        if (checkbox.checked !== isSelected) {
          checkbox.click();
        }
      }
    }
  };

  /**
   * Handles the options in the kebab menu
   * @param {boolean} multiple_users true if multiple users are selected
   * @param {boolean} isDeactivatedUser only set if multiple_users is false, true if the user is deactivated
   * @param {boolean} isInvited only set if multiple_users is false, true if the user account has not been activated
     yet through the activation email
   * @param {boolean} isScheduledDelete only set if multiple_users is false, true if the user is scheduled for deletion
     @param {boolean} isOwnAdminUser true if the user or users selected include the admin currently in use - done to prevent 
     actions on their own accounts.
  */
  handleKebabMenuItems = (
    multiple_users = false,
    isDeactivatedUser = false,
    isInvited = false,
    isScheduledDelete = false,
    isOwnAdminUser = false
  ) => {

    if (multiple_users && !isOwnAdminUser) {

      this.setHidden(this.elements.edit, this.selectedUsersID.length !== 1)

      const selected_users = this.users.filter(user => this.selectedUsersID.includes(user.user_id));

      const allActivated = selected_users.every(user => user.status === this.USER_STATUS_ACTIVE);
      const allDeactivated = selected_users.every(user => user.status === this.USER_STATUS_DEACTIVATED);
      const allScheduledDelete = selected_users.every(user => user.status === this.USER_STATUS_DELETED);
      const oneInvited = selected_users.some(user => user.account_active === this.USER_STATUS_NOT_ACTIVE);

      if (allActivated && !oneInvited) {
        this.setHidden(this.elements.userDeactivate, false);
        this.setHidden(this.elements.userReactivate, true);
        this.setHidden(this.elements.delete, false);
        this.setHidden(this.elements.userRecover, true);
      } else if (allDeactivated) {
        this.setHidden(this.elements.userDeactivate, true);
        this.setHidden(this.elements.userReactivate, false);
        this.setHidden(this.elements.delete, false);
        this.setHidden(this.elements.userRecover, true);
      } else if (allScheduledDelete) {
        this.setHidden(this.elements.userDeactivate, true);
        this.setHidden(this.elements.userReactivate, true);
        this.setHidden(this.elements.delete, true);
        this.setHidden(this.elements.userRecover, false);
      } else if (oneInvited) {
        this.setHidden(this.elements.userDeactivate, true);
        this.setHidden(this.elements.userReactivate, true);
        this.setHidden(this.elements.delete, false);
        this.setHidden(this.elements.userRecover, true);
      } else {
        this.setHidden(this.elements.userDeactivate, true);
        this.setHidden(this.elements.userReactivate, true);
        this.setHidden(this.elements.delete, false);
        this.setHidden(this.elements.userRecover, true);
      }

    } else if (isOwnAdminUser) {
      this.setHidden(this.elements.edit, true)
      this.setHidden(this.elements.userDeactivate, true)
      this.setHidden(this.elements.userReactivate, true)
      this.setHidden(this.elements.delete, true)
      _collow.Notify.info(this.params.toasterselfadminactionnotallowed)
    } else if (isInvited) {
      this.setHidden(this.elements.edit, false)
      this.setHidden(this.elements.userDeactivate, true)
      this.setHidden(this.elements.userReactivate, true)
      this.setHidden(this.elements.delete, false)
    } else if (isScheduledDelete) {
      this.setHidden(this.elements.edit, false)
      this.setHidden(this.elements.userDeactivate, true)
      this.setHidden(this.elements.userReactivate, true)
      this.setHidden(this.elements.delete, true)
      this.setHidden(this.elements.userRecover, false);
    } else {
      this.setHidden(this.elements.edit, false)
      this.setHidden(this.elements.userDeactivate, isDeactivatedUser)
      this.setHidden(this.elements.userReactivate, !isDeactivatedUser)
      this.setHidden(this.elements.delete, false)
    }
  }

  setHidden(element, hidden = true) {
    if (hidden) {
      if (!element.hasAttribute("hidden")) {
        element.setAttribute("hidden", "")
      }
    } else {
      if (element.hasAttribute("hidden")) {
        element.removeAttribute("hidden", "")
      }
    }
  }

  /**
   * Given a list of user ids, returns a list of emails
   * @param {string} ids list of user ids
   * @returns list of emails
   */
  getEmailsFromIDs = (ids) => {
    return this.users.filter(user => ids.includes(user.user_id)).map(user => user.email)
  }

  /**
   * Handles the kebab menu for multiple users
   * @param {*} event 
   */
  onClickMultipleUserKebab = (event) => {
    event.preventDefault();

    if (this.selectedUsersID.length === 0)
      return;

    this.selfAdminCheck = this.selectedUsersEmails.includes(this.loggedAdminAccount) ? true : false

    this.handleKebabMenuItems(true,
      false,
      false,
      false,
      this.selfAdminCheck
    );

    const kebabButton = event.currentTarget
    const row = kebabButton.closest("tr");

    //if the row belongs to a selected user or is the header row, show the kebab menu
    if (this.selectedUsersID.includes(row.dataset.id) || row.dataset.id === undefined)
      this.showKebabMenu(kebabButton);
  }

  /**
   * Handles the kebab menu for a single user
   * @param {*} event 
   */
  onClickUserKebab = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.lastOpenedUserKebab = null;

    if (this.selectedUsersID.length > 0) {
      this.onClickMultipleUserKebab(event);
      return;
    }

    const kebabButton = event.currentTarget;
    const row = kebabButton.closest("tr");
    if (!row) {
      console.error("Row not detected for single user kebab menu");
      return;
    }

    const user = this.users.find(u => u.user_id == row.dataset.id);
    this.lastOpenedUserKebab = user;

    this.handleKebabMenuItems(false, user.status === this.USER_STATUS_DEACTIVATED,
      user.account_active === this.USER_STATUS_NOT_ACTIVE,
      user.status === this.USER_STATUS_DELETED,
      this.loggedAdminAccount === user.email
    );

    this.showKebabMenu(kebabButton);
  }

  /**
   * Shows the kebab menu
   * @param {*} kebabButton 
   */
  showKebabMenu = (kebabButton) => {
    const buttonRect = kebabButton.getBoundingClientRect();

    this.elements.kebabMenu.style.top = `${buttonRect.top}px`;
    this.elements.kebabMenu.style.right = '100px'
    this.elements.kebabMenu.toggleAttribute("hidden")
  }

  /**
   * Handles the closing of the popups and kebab menu when clicked outside of
   */
  handlePopupsClose = () => {
    this.listen(document, "click", (event) => {
      if (!event.target.closest(".kebab-menu")) {
        this.elements.kebabMenu.setAttribute("hidden", "");
      }

      if (!event.target.closest(".admin-dashboard-users__popups")) {
        if (!this.elements.deletePopup.hasAttribute("hidden"))
          this.showHideDeletePopup();
        if (!this.elements.massDeletePopup.hasAttribute("hidden"))
          this.showHideMassDeletePopup();
        if (!this.elements.deactivatePopup.hasAttribute("hidden"))
          this.showHideDeactivatePopup();
      }
    })
  }

  onClickEditUserButton = () => {

    if (this.selectedUsersID.length == 1)
      this.lastOpenedUserKebab = this.users.find(user => user.user_id == this.selectedUsersID[0]);

    if (this.lastOpenedUserKebab != null && this.lastOpenedUserKebab != undefined) {
      this.setHidden(document.querySelector(".user-kebab-menu"), true)
      this.editUser()
    } else {
      console.error("One person can be edited at a time")
    }
  }
  onClickDeleteUserButton = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    this.setHidden(document.querySelector(".user-kebab-menu"), true)

    if (this.selectedUsersID.length > 0) {
      this.showHideMassDeletePopup()
      this.dispatch(this.root, "_collow.popup", { type: "open" });

      if (this.originalText == null)
        this.originalText = this.elements.deleteMassUserText.textContent;

      this.elements.deleteMassUserText.textContent = this.originalText.replace("{users}", this.selectedUsersID.length)

      this.setHidden(this.elements.deleteMassUserTimerConfirmation, true);
      await this.startCountdown(this.elements.deleteMassUserTimer, 5);
      this.elements.confirmMassDelete.toggleAttribute("disabled", false);
      this.setHidden(this.elements.deleteMassUserTimerConfirmation, false);
    }
    else {
      this.showHideDeletePopup()
      this.dispatch(this.root, "_collow.popup", { type: "open" });

      this.setHidden(this.elements.deleteSingleUserTimerConfirmation, true);
      await this.startCountdown(this.elements.deleteSingleUserTimer, 5);
      this.elements.confirmDelete.toggleAttribute("disabled", false);
      this.setHidden(this.elements.deleteSingleUserTimerConfirmation, false);
    }
  }

  startCountdown = (textElement, duration = 5) => {
    return new Promise(resolve => {
      this.setHidden(textElement, false);
      let counter = duration;
      let originalText = textElement.textContent;

      const countdownLogic = () => {
        textElement.textContent = originalText.replace("{time}", counter);
        counter--;
        if (counter < 0) {
          clearInterval(countdown);
          this.setHidden(textElement, true);
          textElement.textContent = originalText;
          resolve();
        }
      };


      countdownLogic();
      let countdown = setInterval(countdownLogic, 1000);
    });
  }

  deselectAll = () => {
    this.setHidden(document.querySelector(".user-kebab-menu"), true)
    this.dispatch(this.root, "_collow.popup", { type: "close" });
    this.onClickCancelImportButton()
  };

  /**
   * @param {*} state keep track of if there is a eventlistener active and if the popup is active.
   * Arranges popup to show/hide and adds/removes eventlisteners to the buttons
   */
  showHideDeletePopup = (state = false) => {
    this.elements.deletePopup.myState =
      this.elements.deletePopup.myState == undefined
        ? state
        : !this.elements.deletePopup.myState;

    const newState = this.elements.deletePopup.myState;

    this.elements.deletePopup.toggleAttribute("hidden");
    this[newState ? "unlisten" : "listen"](
      this.elements.confirmDelete,
      "click",
      () => this.deleteUsers(false)
    );
    this[newState ? "unlisten" : "listen"](
      this.elements.cancelDelete,
      "click",
      this.showHideDeletePopup
    );

    this.elements.confirmDelete.toggleAttribute("disabled", true);

    state && this.deselectAll();
    if (this.errorbox) {
      this.errorbox = false;
      this.dispatch(this.root, "_collow-input-change");
    }
  };

  showHideMassDeletePopup = (state = false) => {
    this.elements.massDeletePopup.myState =
      this.elements.massDeletePopup.myState == undefined
        ? state
        : !this.elements.massDeletePopup.myState;

    const newState = this.elements.massDeletePopup.myState;

    this.elements.massDeletePopup.toggleAttribute("hidden");
    this[newState ? "unlisten" : "listen"](
      this.elements.confirmMassDelete,
      "click",
      () => this.deleteUsers(true)
    );
    this[newState ? "unlisten" : "listen"](
      this.elements.cancelMassDelete,
      "click",
      this.showHideMassDeletePopup
    );

    if (this.originalText != null)
      this.elements.deleteMassUserText.textContent = this.originalText;

    this.elements.confirmMassDelete.toggleAttribute("disabled", true);

    state && this.deselectAll();
    if (this.errorbox) {
      this.errorbox = false;
      this.dispatch(this.root, "_collow-input-change");
    }
  }

  /**
   * @param {*} state keep track of if there is a eventlistener active and if the popup is active.
   * Arranges popup to show/hide and adds/removes eventlisteners to the buttons
   */
  showHideDeactivatePopup = (state = false) => {
    this.elements.deactivatePopup.myState =
      this.elements.deactivatePopup.myState == undefined
        ? state
        : !this.elements.deactivatePopup.myState;

    const newState = this.elements.deactivatePopup.myState;

    this.elements.deactivatePopup.toggleAttribute("hidden");
    this[newState ? "unlisten" : "listen"](
      this.elements.confirmDeactivate,
      "click",
      this.deactivateUsers
    );
    this[newState ? "unlisten" : "listen"](
      this.elements.cancelDeactivate,
      "click",
      this.showHideDeactivatePopup
    );

    state && this.deselectAll();
    if (this.errorbox) {
      this.errorbox = false;
      this.dispatch(this.root, "_collow-input-change");
    }
  };

  activateUsers = async () => {
    let emails = []

    if (this.selectedUsersID.length > 0) {
      emails = this.getEmailsFromIDs(this.selectedUsersID);
    } else {
      emails = [this.lastOpenedUserKebab.email];
    }

    const formData = new FormData();
    formData.append("emails", emails.join(","));

    const url = this.params.path + "/admin/reactivate_users"

    const response = await fetch(url, {
      method: "put",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: formData,
    });
    const resJson = await response.json();

    if (!response.ok) {
      this.dispatch(this.root, "_collow-custom-error", resJson);
    }

    await this.getUsers();
    this.deselectAll();
  }

  deactivateUsers = async () => {
    let emails = []

    if (this.selectedUsersID.length > 0) {
      emails = this.getEmailsFromIDs(this.selectedUsersID);
    } else {
      emails = [this.lastOpenedUserKebab.email];
    }

    const formData = new FormData();
    formData.append("emails", emails.join(","));

    const url = this.params.path + "/admin/deactivate_users"

    const response = await fetch(url, {
      method: "put",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: formData,
    });
    const resJson = await response.json();
    if (!response.ok) {
      this.dispatch(this.root, "_collow-custom-error", resJson);
    }

    this.showHideDeactivatePopup();
    await this.getUsers();
    this.deselectAll();
  };

  deleteUsers = async (massUserDialog = false) => {
    try {
      let emailsToDelete = [];

      if (this.selectedUsersID.length > 0) {
        emailsToDelete = this.getEmailsFromIDs(this.selectedUsersID);
      } else {
        emailsToDelete = [this.lastOpenedUserKebab.email];
      }

      const formData = new FormData();
      formData.append("emails", emailsToDelete.join(","));

      const response = await fetch(this.params.path + "/admin/schedule_delete", {
        method: "post",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
        body: formData,
      });

      const resJson = await response.json();
      if (!response.ok) {
        if (resJson?.detail["error_code"] == "admin_conflict-in-delete-user") {
          const conflicts = resJson.detail.info.conflicts;
          const errors = conflicts.map(
            (user) => `<p>${user.user}: ${user.detail}</p>`
          );
          this.dispatch(this.root, "_collow.error-with-input", { err: errors });
          this.errorbox = true;
          return;
        }
        this.dispatch(this.root, "_collow-custom-error", resJson);
      }

      if (massUserDialog == true) {
        if (!this.elements.massDeletePopup.hasAttribute("hidden")) {
          this.showHideMassDeletePopup();
        }
      } else {
        if (!this.elements.deletePopup.hasAttribute("hidden")) {
          this.showHideDeletePopup();
        }
      }

      this.getUsers();
      this.deselectAll();
    } catch (err) {
      this.dispatch(this.root, "_collow-custom-error");
    }
  };

  onClickRecoverButton = async () => {

    if (this.selectedUsersID.length + this.currentUsers > this.whitelabelFeatureAccess.max_users) {
      _collow.Notify.info(this.params.recoveryerrorspace, { actionLabel: this.params.visitsupport, href: this.params.supportlink })
      return
    }

    let emailsToReactivate = [];

    if (this.selectedUsersID.length > 0) {
      emailsToReactivate = this.getEmailsFromIDs(this.selectedUsersID);
    } else {
      emailsToReactivate = [this.lastOpenedUserKebab.email];
    }

    const formData = new FormData();
    formData.append("emails", emailsToReactivate.join(","));

    const response = await fetch(this.params.path + "/admin/rollback_delete", {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: formData,
    });

    const resJson = await response.json();
    if (!response.ok) {
      if (resJson?.detail["error_code"] == "admin_conflict-in-delete-user") {
        const conflicts = resJson.detail.info.conflicts;
        const errors = conflicts.map(
          (user) => `<p>${user.user}: ${user.detail}</p>`
        );
        this.dispatch(this.root, "_collow.error-with-input", { err: errors });
        this.errorbox = true;
        return;
      }
      this.dispatch(this.root, "_collow-custom-error", resJson);
    }

    _collow.Notify.success(this.params.recoverymessage)

    this.getUsers();
    this.deselectAll();

  }

  editUser = () => {
    const url = new URL("/admin/edit-user", window.location.origin);
    url.searchParams.append("id", this.lastOpenedUserKebab.user_id);
    window.location = url;
  };

  enableButton = (button) => {
    button.removeAttribute("data-disabled");
  };
  disableButton = (button) => {
    button.setAttribute("data-disabled", "");
  };

  onClickBulkUserImportPopup = () => {
    let userCount = parseInt(this.currentUsers, 10)

    // If the current number of users is higher than the maximum allowed users, block the bulk import button and show a toaster
    if (userCount >= this.maxUsers) {
      _collow.Notify.error(this.params.maxuserlimitmessage, { actionLabel: this.params.visitsupport, href: this.params.supportlink, size: "large" });
    }
    else {
      this.elements.importPopup.toggleAttribute("hidden");
      this.elements.importError.setAttribute("hidden", "");
      this.dispatch(this.root, "_collow.popup", { type: "open" });
    }
  };

  fileCounter = () => {
    if (this.uploadCounter == 0) {
      _collow.Notify.info(this.params.afilealreadyuploaded)
    } else {
      this.uploadCounter = 0
    }
  }

  changeBulkPopupContent = (status) => {
    if (status) {
      this.elements.dragDropIcon.setAttribute('hidden', '')
      this.elements.dragDropIconDropped.removeAttribute('hidden')
      document.querySelectorAll('[data-js="drag-drop-text"]').forEach(p => p.setAttribute('hidden', ''))
      this.elements.dragDropNewText.removeAttribute('hidden')
      this.elements.dragDropNewText.textContent = this.fileInput.name
      return
    }
    this.elements.importFile.value = ''
    this.elements.dragDropIcon.removeAttribute('hidden')
    this.elements.dragDropIconDropped.setAttribute('hidden', '')
    document.querySelectorAll('[data-js="drag-drop-text"]').forEach(p => p.removeAttribute('hidden'))
    this.elements.dragDropNewText.setAttribute('hidden', '')
  }

  fileInputChange = (e) => {
    this.fileInput = e.target.files[0]

    this.changeBulkPopupContent(true)
  }

  dropHandler = (dragDropEvent) => {
    dragDropEvent.preventDefault();
    dragDropEvent.stopPropagation();

    if (dragDropEvent.dataTransfer.files[0].type == 'text/csv') {
      this.fileInput = dragDropEvent.dataTransfer.files[0];
      this.changeBulkPopupContent(true)
      dragDropEvent = null;
      this.fileCounter();
      return this.fileInput;
    } else {
      _collow.Notify.error(this.params.wrongfileformat)
    }
  }

  importedUsersData;
  onClickBulkUserImportButton = () => {
    if (this.fileInput === null) {
      if (this.elements.importFile != null) {
        this.fileInput = this.elements.importFile.files[0];
      }
    }

    if (this.fileInput) {
      this.changeBulkPopupContent(false)
      _collow.Notify.info(this.params.loadingmessage)
      const formData = new FormData();
      formData.append("bulk_file", this.fileInput);

      fetch(this.params.path + "/admin/user/bulk-import", {
        method: "POST",
        body: formData,
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
        .then(async (response) => {
          if (response.status === 403) {
            _collow.Notify.error(this.params.maxuserlimitmessage, { actionLabel: this.params.visitsupport, href: this.params.supportlink, size: "large" });
            return;
          }

          const responseData = await response.json();
          if (!response.ok) {
            _collow.Notify.error(this.params.generalerrorbulk)
            throw new Error(responseData.detail);
          }
          this.importedUsersData = responseData;
          this.hideError();
          this.elements.importErrorIcon.setAttribute('hidden', '');
          this.setHidden(this.elements.importPopup, true);
          this.setHidden(this.elements.importPopupResults, false);
          this.setHidden(this.elements.cancelImportB, false);

          var success = 0;
          var successNoGroup = 0;
          var successInvalidGroup = 0;
          var errorEmailUsed = 0;
          var errorNoEmail = 0;
          var errorNoFirstname = 0;
          var errorNoLastname = 0;

          for (var i = 0; i < this.importedUsersData.length; i++) {
            if (this.importedUsersData[i].import_success === true &&
              this.importedUsersData[i].import_status.length === 0) {
              success += 1;
            } else if (this.importedUsersData[i].import_success === true &&
              this.importedUsersData[i].import_status.includes('no group')) {
              successNoGroup += 1;
            } else if (this.importedUsersData[i].import_success === true &&
              this.importedUsersData[i].import_status.includes('group not found')) {
              successInvalidGroup += 1;
            } else if (this.importedUsersData[i].import_status.includes('email already in use')) {
              errorEmailUsed += 1;
            } else if (this.importedUsersData[i].import_status.includes('no email')) {
              errorNoEmail += 1;
            } else if (this.importedUsersData[i].import_status.includes('no firstname')) {
              errorNoFirstname += 1;
            } else if (this.importedUsersData[i].import_status.includes('no lastname')) {
              errorNoLastname += 1;
            }
          }

          document.getElementsByClassName("nr-success")[0].textContent = success;
          document.getElementsByClassName("nr-success-no-group")[0].textContent = successNoGroup;
          document.getElementsByClassName("nr-success-invalid-group")[0].textContent = successInvalidGroup;
          document.getElementsByClassName("nr-error-email-used")[0].textContent = errorEmailUsed;
          document.getElementsByClassName("nr-error-no-email")[0].textContent = errorNoEmail;
          document.getElementsByClassName("nr-error-no-firstname")[0].textContent = errorNoFirstname;
          document.getElementsByClassName("nr-error-no-lastname")[0].textContent = errorNoLastname;

          if (Object.values(this.importedUsersData).reduce((f, { import_success }) => f + import_success, 0) === this.importedUsersData.length) {
            if (success >= 1) {
              this.setHidden(this.elements.resultsSuccess, false);
            }
            if (successNoGroup >= 1) {
              this.setHidden(this.elements.resultsSuccessNoGroup, false);
            }
            if (successInvalidGroup >= 1) {
              this.setHidden(this.elements.resultsSuccessInvalidGroup, false);
            }
            this.enableButton(this.elements.confirmImportResult);
            this.setHidden(this.elements.confirmImportResult, false);
          } else {
            this.enableButton(this.elements.downloadFailed);
            this.setHidden(this.elements.downloadFailed, false);
            this.enableButton(this.elements.addOkImport);
            this.setHidden(this.elements.addOkImport, false);
            if (errorEmailUsed >= 1) {
              this.setHidden(this.elements.resultsErrorEmailUsed, false);
            }
            if (errorNoEmail >= 1) {
              this.setHidden(this.elements.resultsErrorNoEmail, false);
            }
            if (errorNoFirstname >= 1) {
              this.setHidden(this.elements.resultsErrorNoFirstname, false);
            }
            if (errorNoLastname >= 1) {
              this.setHidden(this.elements.resultsErrorNoLastname, false);
            }
            if (Object.values(this.importedUsersData).reduce((f, { import_success }) => f + import_success, 0) === 0) {
              this.disableButton(this.elements.addOkImport);
              this.setHidden(this.elements.addOkImport, true);
            } else {
              if (success >= 1) {
                this.setHidden(this.elements.resultsSuccess, false);
              }
              if (successNoGroup >= 1) {
                this.setHidden(this.elements.resultsSuccessNoGroup, false);
              }
              if (successInvalidGroup >= 1) {
                this.setHidden(this.elements.resultsSuccessInvalidGroup, false);
              }
            }
          }
          return this.importedUsersData;
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      _collow.Notify.error(this.params.nofileerror)
    }
  };

  onClickDownloadFailedButton = () => {
    if (this.importedUsersData && this.importedUsersData.length > 0) {
      const failedImports = this.importedUsersData.filter((user) =>
        user.import_success == false
      );

      if (failedImports.length === 0) {
        console.error("No failed imports available for download");
        return;
      }

      const formattedUsers = failedImports.map((user) => ({
        firstname: user.firstname || "",
        prefix: user.prefix || "",
        lastname: user.lastname || "",
        email: user.email,
        groups: user.groups || [],
        import_status: user.import_status || [],
      }));

      fetch(this.params.path + "/admin/user/bulk-import/download-failed", {
        method: "POST",
        body: JSON.stringify(formattedUsers),
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to download failed imports");
          }
          return response.blob();
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = "failed_bulk_user_import.csv";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Error downloading failed imports:", error);
          _collow.Notify.error(this.params.generalerrorbulk)
        });
    }
  };

  onClickCancelImportButton = () => {
    this.changeBulkPopupContent(false)
    this.elements.importError.setAttribute("hidden", "");
    this.elements.importErrorIcon.setAttribute("hidden", "")
    this.setHidden(this.elements.importPopup, true);
    this.getUsers();
    this.disableButton(this.elements.downloadFailed);
    this.setHidden(this.elements.downloadFailed, true);
    this.disableButton(this.elements.addOkImport);
    this.setHidden(this.elements.addOkImport, true)
    this.disableButton(this.elements.confirmImport);
    this.disableButton(this.elements.confirmImportResult);
    this.setHidden(this.elements.confirmImportResult, true);
    this.fileInput = null;
    // this.elements.importFile = null;   //TODO: Bug, if this is set to null, it will not allow you to import a filevia the upload button until you refresh the page
    this.importedUsersData = null;
    this.setHidden(this.elements.importPopupResults, true);
    this.setHidden(this.elements.resultsSuccess, true);
    this.setHidden(this.elements.resultsSuccessNoGroup, true);
    this.setHidden(this.elements.resultsSuccessInvalidGroup, true);
    this.setHidden(this.elements.resultsErrorEmailUsed, true);
    this.setHidden(this.elements.resultsErrorNoEmail, true);
    this.setHidden(this.elements.resultsErrorNoFirstname, true);
    this.setHidden(this.elements.resultsErrorNoLastname, true);
    this.setHidden(this.elements.closeSuccessfulImport, true)
    this.dispatch(this.root, "_collow.popup", { type: "close" });
    this.checkUserLimitFlags(); //Check user limit flags and display toaster notifications if necessary
    this.uploadCounter = 1;
  };

  onClickAddOkImportButton = async () => {
    let res = [];

    try {
      const serverRes = await this.addUser(this.importedUsersData);
      res.push(serverRes);
    } catch (error) {
      console.error(error);
    }

    _collow.Notify.success(this.params.bulkimportsuccess)

    this.setImportMessageResult(
      `${this.importedUsersData.filter((user) =>
        user.import_success == true).length} users added successfully, 
            ${this.importedUsersData.filter((user) =>
          user.import_success == false).length} users not added due to errors.`,
      false
    );
    this.setHidden(this.elements.closeSuccessfulImport, false);
    this.setHidden(this.elements.cancelImportB, true);
    this.setHidden(this.elements.addOkImport, true);
    this.setHidden(this.elements.confirmImportResult, true);

    this.updateUserCount()
  }

  setImportMessage = (text, err = true) => {
    this.elements.importError.textContent = text;
    if (err) {
      if (!this.elements.importError.classList.contains("error")) {
        this.elements.importError.classList.add("error")
      }
    } else {
      if (this.elements.importError.classList.contains("error")) {
        this.elements.importError.classList.remove("error")
      }
    }
    this.elements.importError.removeAttribute('hidden');
    this.elements.importErrorIcon.removeAttribute('hidden')
  };

  setImportMessageResult = (text, err = true) => {
    this.elements.importErrorBulkResult.textContent = text;
    if (err) {
      if (!this.elements.importErrorBulkResult.classList.contains("error")) {
        this.elements.importErrorBulkResult.classList.add("error")
      }
    } else {
      if (this.elements.importErrorBulkResult.classList.contains("error")) {
        this.elements.importErrorBulkResult.classList.remove("error")
      }
    }
    this.elements.importErrorBulkResult.removeAttribute('hidden');
  };

  hideError = () => {
    this.elements.importError.setAttribute('hidden', '');
  };

  addUser = async (formData) => {
    try {
      const response = await fetch(this.params.path + "/admin/user/bulk-import/confirm", {
        method: "post",
        body: JSON.stringify(formData),
        headers: {
          Authorization: localStorage.getItem("token"),
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to add user');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  };


  onClickDeactivateButton = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setHidden(document.querySelector(".user-kebab-menu"), true)

    if (this.selectedUsersID.length > 0) {
      this.showHideDeactivatePopup()
      this.dispatch(this.root, "_collow.popup", { type: "open" });
    }
    else {
      this.showHideDeactivatePopup()
      this.dispatch(this.root, "_collow.popup", { type: "open" });
    }
  };

  onClickReactivateButton = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setHidden(document.querySelector(".user-kebab-menu"), true)

    if (this.selectedUsersID.length < 2) {
      _collow.Notify.success(this.params.toasterreactivateuser)
    }
    else {
      _collow.Notify.success(this.params.toasterreactivateusers)
    }
    this.activateUsers()
  };

  onSearch = async (query) => {
    // Convert query to lowercase for case-insensitive comparison
    const lowerCaseQuery = query.toLowerCase();
    query.length === 0 ? this.searchQueryActive = false : this.searchQueryActive = true;
    this.searchQuery = lowerCaseQuery

    this.facilitateSFS()
  };

  // Function that facilitates sorting functionality for all collumns
  sortBy = (array, key, direction = 'ascending') => {
    key === 'name' ? key = 'fullName' : null
    const res = array.sort((a, b) => {
      // It will first consider if the sorter key is string, if its not string, then check if it's a number and convert it to string (for statuses), 
      // if it's not a number then check if the user is groupless and assign 0 so that the sorter separates users with valid groups
      const itemA = (typeof a[key] === 'string') ? a[key].toLowerCase() : (key === 'status') ? this.statusToString(a) : (key === 'role') ? this.roleToString(a) : 
        (a[key].includes('groupLess')) ? 0 : a[key].length
      const itemB = (typeof b[key] === 'string') ? b[key].toLowerCase() : (key === 'status') ? this.statusToString(b) : (key === 'role') ? this.roleToString(b) : 
        (b[key].includes('groupLess')) ? 0 : b[key].length

      if (itemA < itemB) return -1
      if (itemA > itemB) return 1
      return 0
    })

    return direction === 'ascending' ? res : res.reverse()
  }

  // converts the number of the status to the corresponding string text
  statusToString = (item) => {
    if (item.account_active === false && item.status === 1) {
      return this.params.invitedstatus
    } else if (item.status === 1) {
      return this.params.activestatus;
    } else if (item.status === 3) {
      return this.params.deactivatedstatus;
    } else if (item.status === 4) {
      return this.params.deletedstatus;
    }
  }

  roleToString = (item) => {
  if (typeof item.role === 'number') {
    return item.role === 1 ? 'admin' : 'user';
  }
  return 'unknown'; 
  };

  // Sorts table
  tableSort = async (sorter) => {

    this.trackerTable[sorter] = (this.trackerTable[sorter] === 'ascending') ? 'descending' : 'ascending';
    this.sorterActive = true;

    for (let key in this.trackerTable) {  //if looking to make sorters interact -> start by removing this for loop!
      if (key !== sorter) {
        this.trackerTable[key] = null;
      } else {
        if (key == 'name') {
          for (let i = 0; i < this.users.length; i++) {
            const fullName = `${this.users[i].firstname || ''} ${this.users[i].prefix || ''} ${this.users[i].lastname || ''}`
              .replace(/\s+/g, ' ').trim();

            this.users[i].fullName = fullName
          }
        }
        this.changeSortIcon(sorter, this.trackerTable[sorter]);

        this.facilitateSFS()
      }
    }
  }

  // makes the sort icons change when pressed
  changeSortIcon = async (sorter, direction) => {
    const elementId = `${sorter}Sort`
    const columnSorters = ["nameSort", "emailSort", "groupsSort", "statusSort", "roleSort"]
    const clickedSorter = columnSorters.indexOf(elementId)

    if (clickedSorter > -1) {
      columnSorters.splice(clickedSorter, 1)
    }

    columnSorters.forEach((elementId) => {
      if ((document.getElementById(elementId).classList.contains('fa-caret-up')) || (document.getElementById(elementId).classList.contains('fa-caret-down'))) {
        document.getElementById(elementId).classList.remove('fa-caret-up', 'fa-caret-down')
        document.getElementById(elementId).classList.add('fa-sort')
      }
    })

    document.getElementById(elementId).classList.remove('fa-sort', 'fa-caret-up', 'fa-caret-down')
    if (direction === 'ascending') {
      document.getElementById(elementId).classList.add('fa-caret-up')
    } else if (direction === 'descending') {
      document.getElementById(elementId).classList.add('fa-caret-down')
    }
  }

  /** get all groups, put them in an array, create elements */
  getGroups = async () => {

    const response = await fetch(this.params.path + "/admin/group/all", {
      method: "get",
      headers: {
        Authorization: window.localStorage.getItem("token"),
      },
    });
    if (!response.ok) return;

    this.groupList = await response.json();

    const ulGroupList = document.querySelector(".groupList")
    for (let i = -2; i < this.groupList.length; i++) {

      const li = document.createElement("li");
      const input = document.createElement("input");
      const label = document.createElement('label');
      li.style.padding = "8px";
      input.style.marginRight = "8px";
      input.type = 'checkbox';

      if (i === -2) {
        input.setAttribute(`data-admin-control-users:gAll`, "");
        input.setAttribute("checked", "");
        input.name = 'groupsAll';
        label.for = 'groupsAll';
        label.textContent = this.params.filterall;

        li.appendChild(input);
        li.appendChild(label);
        ulGroupList.appendChild(li);

        this.listen(input, "click", () => this.onClick('group', 'all'));

      } else if (i === -1) {
        input.setAttribute(`data-admin-control-users:g0`, "");
        input.setAttribute("checked", "");
        input.name = 'groupsLess';
        label.for = 'groupsLess';
        label.textContent = this.params.filtergroupless;

        li.appendChild(input);
        li.appendChild(label);
        ulGroupList.appendChild(li);

        this.listen(input, "click", () => this.onClick('group', 0));
      } else {

        li.classList.add('groupNameRow')
        input.setAttribute(`data-admin-control-users:g${i + 1}`, "");
        input.setAttribute("checked", "");
        input.name = this.groupList[i].name;
        label.for = this.groupList[i].name;
        label.textContent = this.groupList[i].name;
        label.classList.add("groupName", "notranslate")

        this.visibleGroups.push(this.groupList[i].name);

        li.appendChild(input);
        li.appendChild(label);

        this.groupFilterDict.push({
          name: this.groupList[i].name,
          value: true,
        })

        this.listen(input, "click", () => this.onClick('group', i + 1));

        ulGroupList.appendChild(li);
      }
    }
    this.groupFilterDict.unshift({
      name: 'groupLess',
      value: true,
    })
    this.visibleGroups.push('groupLess');
    return ulGroupList
  };

  getRoles = async () => {
    const ulRoleList = document.querySelector(".roleList");
    const userRoles = [this.params.userrole, this.params.adminrole]

    for (let i = 0; i < userRoles.length; i++) {
      const li = document.createElement("li");
      const input = document.createElement("input");
      const label = document.createElement('label');
      li.style.padding = "8px";
      input.style.marginRight = "8px";
      input.type = 'checkbox';

      li.classList.add('roleNameRow')
      input.setAttribute(`data-admin-control-users:r${i}`, "");
      input.setAttribute("checked", "");
      input.name = userRoles[i];
      label.for = userRoles[i];
      label.textContent = userRoles[i];
      label.classList.add("roleName")

      this.visibleRoles.push(userRoles[i]);

      li.appendChild(input);
      li.appendChild(label);

      this.listen(input, "click", () => this.onClick('role', i));

      this.roleFilterDict.push({
        role: userRoles[i],
        roleInteger: i + 1,
        value: true,
      })

      ulRoleList.appendChild(li);
    }
  }

  /** create elements for each status */
  getStatus = async () => {
    const ulStatusList = document.querySelector(".statusList");
    const userStatuses = ['Active', 'Deactivated', 'Invited', 'Deleted']
    const userStatusesSanity = [this.params.activestatus, this.params.deactivatedstatus, this.params.invitedstatus, this.params.deletedstatus] //in order as previous variable

    for (let i = -1; i < userStatuses.length; i++) {
      const li = document.createElement("li");
      const input = document.createElement("input");
      const label = document.createElement('label');
      li.style.padding = "8px";
      input.style.marginRight = "8px";
      input.type = 'checkbox';

      if (i === -1) {
        input.setAttribute(`data-admin-control-users:sAll`, "");
        input.setAttribute("checked", "");
        input.name = 'statusAll';
        label.for = 'statusAll';
        label.textContent = this.params.filterall;

        li.appendChild(input);
        li.appendChild(label);
        ulStatusList.appendChild(li);

        this.listen(input, "click", () => this.onClick('status', 'all'));
      } else {

        li.classList.add('statusNameRow')
        input.setAttribute(`data-admin-control-users:s${i}`, "");
        input.setAttribute("checked", "");
        input.name = userStatuses[i];
        label.for = userStatuses[i];
        label.textContent = userStatusesSanity[i];
        label.classList.add("statusName")

        this.visibleStatuses.push(userStatuses[i]);

        li.appendChild(input);
        li.appendChild(label);

        this.listen(input, "click", () => this.onClick('status', i));

        this.statusFilterDict.push({
          status: userStatuses[i],
          value: true,
        })

        ulStatusList.appendChild(li);
      }
    }
    return ulStatusList
  };

  /**
  * Shows the group filter menu 
  */
  showGroupFilterMenu = () => {
    const groupFilterElement = document.querySelector(".group-filter-icon");
    const filterPosition = groupFilterElement.getBoundingClientRect();

    this.elements.groupFilterMenu.style.top = `calc(${filterPosition.top}px + 3%)`;
    this.elements.groupFilterMenu.style.left = `calc(${filterPosition.left}px - 14%)`;
    this.elements.groupFilterMenu.toggleAttribute("hidden")

    this.ulGroupList
  }

  showRoleFilterMenu = () => {
    const roleFilterElement = document.querySelector(".role-filter-icon");
    const filterPosition = roleFilterElement.getBoundingClientRect();

    this.elements.roleFilterMenu.style.top = `calc(${filterPosition.top}px + 3%)`;
    this.elements.roleFilterMenu.style.left = `calc(${filterPosition.left}px - 8%)`;
    this.elements.roleFilterMenu.toggleAttribute("hidden")

    this.ulRoleList
  }

  /**
   * Shows the status filter menu
   */
  showStatusFilterMenu = () => {
    const statusFilterElement = document.querySelector(".status-filter-icon");
    const filterPosition = statusFilterElement.getBoundingClientRect();

    this.elements.statusFilterMenu.style.top = `calc(${filterPosition.top}px + 3%)`;
    this.elements.statusFilterMenu.style.left = `calc(${filterPosition.left}px - 14%)`;
    this.elements.statusFilterMenu.toggleAttribute("hidden")

    this.ulStatusList
  }

  onFilterSearch = async (type, query) => {

    const lowerCaseQuery = query.toLowerCase();
    for (let i = 0; i < document.getElementsByClassName(`${type}NameRow`).length; i++) {
      if (document.getElementsByClassName(`${type}Name`)[i].textContent.toLowerCase().includes(lowerCaseQuery)) {
        document.getElementsByClassName(`${type}NameRow`)[i].style.display = '';
      } else {
        document.getElementsByClassName(`${type}NameRow`)[i].style.display = 'none';
      }
    }
  }

  /*Facilitates changes caused by using filters */
  onClick = async (param, number, all) => {

    // Push an element in an array only if it's not already in the array
    const conditionalPush = (targetArray, arrayValue) => {
      if (!targetArray.includes(arrayValue)) {
        targetArray.push(arrayValue)
      }
    }

    // Remove an element in an array but only if it exists
    const arrayRemove = (targetArray, arrayValue) => {
      if (targetArray.includes(arrayValue)) {
        const index = targetArray.indexOf(arrayValue)
        targetArray = targetArray.splice(index, 1)
      }
    }

    // Gets the status of the All checkbox and changes it to the opposite
    const getAllstatus = (type) => {
      if (document.querySelector(`[data-admin-control-users\\:${type.charAt(0)}All]`).hasAttribute('checked')) {
        document.querySelector(`[data-admin-control-users\\:${type.charAt(0)}All]`).removeAttribute('checked')
        document.querySelector(`[data-admin-control-users\\:${type.charAt(0)}All]`).checked = false;
        (type === 'group') ? this.visibleGroups = [] : this.visibleStatuses = [], this.visibleRoles = []
        return true
      } else {
        document.querySelector(`[data-admin-control-users\\:${type.charAt(0)}All]`).setAttribute("checked", true)
        document.querySelector(`[data-admin-control-users\\:${type.charAt(0)}All]`).checked = true;
        return false
      }
    }

    // switches statuses of every other checkbox depending on the All checkbox
    const checkboxSwitch = (array, type, arrayStatus) => {
      if (arrayStatus === true) {
        for (let i = 0; i < array.length; i++) {
          array[i].value = false;
          document.querySelector(`[data-admin-control-users\\:${type.charAt(0)}${i}]`).removeAttribute('checked')
          document.querySelector(`[data-admin-control-users\\:${type.charAt(0)}${i}]`).checked = false;
        }
      } else if (arrayStatus === false) {
        for (let i = 0; i < array.length; i++) {
          array[i].value = true;
          document.querySelector(`[data-admin-control-users\\:${type.charAt(0)}${i}]`).removeAttribute('checked')
          document.querySelector(`[data-admin-control-users\\:${type.charAt(0)}${i}]`).setAttribute('checked', "")
          document.querySelector(`[data-admin-control-users\\:${type.charAt(0)}${i}]`).checked = true;
        }
      }
      for (let i = 0; i < array.length; i++) {
        if (type === 'group') {
          array[i].value ? conditionalPush(this.visibleGroups, array[i].name) : null
        } else if (type === 'status') {
          array[i].value ? conditionalPush(this.visibleStatuses, array[i].status) : null;
        } else if (type === 'role') {
          array[i].value ? conditionalPush(this.visibleRoles, array[i].role) : null;
        }
      }
    }

    if (number === 'all') {
      checkboxSwitch(param == 'group' ? this.groupFilterDict : param == 'status' ? this.statusFilterDict : this.roleFilterDict, param, getAllstatus(param))

    } else if (param === 'group') {
      document.querySelector(`[data-admin-control-users\\:${param.charAt(0)}all`).removeAttribute('checked')
      document.querySelector(`[data-admin-control-users\\:${param.charAt(0)}all`).checked = false;
      this.groupFilterDict[number].value ? this.groupFilterDict[number].value = false : this.groupFilterDict[number].value = true;
      for (let i = 0; i < this.groupFilterDict.length; i++) {
        this.groupFilterDict[i].value ? conditionalPush(this.visibleGroups, this.groupFilterDict[i].name) : arrayRemove(this.visibleGroups, this.groupFilterDict[i].name);
      }
    } else if (param === 'status') {
      document.querySelector(`[data-admin-control-users\\:${param.charAt(0)}all`).removeAttribute('checked')
      document.querySelector(`[data-admin-control-users\\:${param.charAt(0)}all`).checked = false;
      this.statusFilterDict[number].value ? this.statusFilterDict[number].value = false : this.statusFilterDict[number].value = true;
      for (let i = 0; i < this.statusFilterDict.length; i++) {
        this.statusFilterDict[i].value ? conditionalPush(this.visibleStatuses, this.statusFilterDict[i].status) : arrayRemove(this.visibleStatuses, this.statusFilterDict[i].status);
      }
    } else if (param === 'role') {
      this.roleFilterDict[number].value ? this.roleFilterDict[number].value = false : this.roleFilterDict[number].value = true;
      for (let i = 0; i < this.roleFilterDict.length; i++) {
        this.roleFilterDict[i].value ? conditionalPush(this.visibleRoles, this.roleFilterDict[i].role) : arrayRemove(this.visibleRoles, this.roleFilterDict[i].role);
      }
    }
    this.filterActive = true
    this.facilitateSFS()
  }


  runFilters = async () => {

    const statusArray = []
    this.visibleStatuses.forEach((status) => {
      if (status === 'Active') {
        statusArray.push(1)
      }
      if (status === 'Deactivated') {
        statusArray.push(3)
      }
      if (status === 'Deleted') {
        statusArray.push(4)
      }
    })

    const roleArray = []
    for (let i = 0; i < this.roleFilterDict.length; i++)
      if (this.roleFilterDict[i].value === true) {
        roleArray.push(this.roleFilterDict[i].roleInteger)
      }

    this.filteredUsers = []

    for (let i = 0; i < this.users.length; i++) {
      console.log(roleArray.includes(this.users[i].role))
      console.log(roleArray, this.users[i].role);

      if ((this.visibleStatuses.includes('Invited')) && (!this.users[i].account_active) &&
        (this.users[i].groups.some(g => this.visibleGroups.includes(g))) &&
        (roleArray.includes(this.users[i].role))) {
        this.filteredUsers.push(this.users[i])
      } else if ((this.users[i].account_active) && (statusArray.includes(this.users[i].status)) &&
        (this.users[i].groups.some(g => this.visibleGroups.includes(g))) &&
        (roleArray.includes(this.users[i].role))) {
        this.filteredUsers.push(this.users[i])
      }
    }
  }

  // function to facilitate Search -> Filter -> Sort
  facilitateSFS = () => {
    // if filter is active, run the user list through the filters, otherwise use the full list
    if (this.filterActive) {
      this.runFilters();
      var visibleUsers = this.filteredUsers
    } else {
      var visibleUsers = this.users
    }

    // if a search query is active, filter based on the search query
    if (this.searchQueryActive) {
      let searchResult = []
      for (let i = 0; i < visibleUsers.length; i++) {
        const fullName = `${visibleUsers[i].firstname || ''} ${visibleUsers[i].prefix || ''} ${visibleUsers[i].lastname || ''}`
          .toLowerCase().replace(/\s+/g, ' ').trim();
        const email = visibleUsers[i].email.toLowerCase();
        (fullName.includes(this.searchQuery) || email.includes(this.searchQuery)) ? searchResult.push(visibleUsers[i]) : null
      }
      visibleUsers = searchResult
    }

    // obtain current active sorter information if sorter is active
    const activeSorter = Object.keys(this.trackerTable).find((key) => this.trackerTable[key] !== null);
    const sorterDirection = this.trackerTable[activeSorter];
    // if a sorter active, immediately use that sorter and its direction when displaying
    (this.sorterActive) ? this.displayUserTable(this.sortBy(visibleUsers, activeSorter, sorterDirection)) : this.displayUserTable(visibleUsers)

  }


  /**
  * @param {Event} event The event object from the click event
  * Handles the click event on the "Add User" button, checks user count against the maximum allowed, 
  * and navigates to add users page or shows a notification if the limit is exceeded.
  */
  onClickAddUserButton = async (event) => {
    let userCount = parseInt(this.currentUsers, 10)

    // If the current number of users is higher than the maximum allowed users, block the add users button and show a toaster
    if (userCount >= this.maxUsers) {
      _collow.Notify.error(this.params.maxuserlimitmessage, { actionLabel: this.params.visitsupport, href: this.params.supportlink, size: "large" });
    } else {
      window.location.href = '/admin/add-users'
    }
  };

  /**
   * Updates the user count and sets flags in localStorage if certain thresholds are reached.
   * Sets a flag if 80% of the user limit is reached and another if the limit is reached.
   */
  updateUserCount = async () => {
    try {
      let previousUserCount = parseInt(this.currentUsers, 10);
      await this.getUserCount();
      let userCount = parseInt(this.currentUsers, 10)

      //Case where the WL is below 80% when starting the import and over 80% after import (Bulk import case).
      //This makes sure that the toaster notification is only shown once after exceeding 80%.
      if (previousUserCount < Math.floor(this.maxUsers * 0.8) && userCount >= Math.floor(this.maxUsers * 0.8)) {
        localStorage.setItem('USER_LIMIT_FLAG_80', 'true');
      } else {
        localStorage.removeItem('USER_LIMIT_FLAG_80');
      }

      //Case where the WL is on 100% after adding/importing user(s)
      if (userCount == this.maxUsers) {
        localStorage.setItem('USER_LIMIT_FLAG', 'true');
      } else {
        localStorage.removeItem('USER_LIMIT_FLAG');
      }
    } catch (error) {
      console.error('Error updating user count:', error);
    }
  }

  /**
   * Checks if user limits have been exceeded and shows notifications accordingly.
   * Adds an event listener to check the flags after the window loads.
   */
  checkUserLimitFlags = async (event) => {
    // Build in a delay for _collow.Notify to initialize
    // Check for the flag that defines that 80 percent of the user limit has been reached
    if (localStorage.getItem("USER_LIMIT_FLAG_80")) {
      _collow.Notify.info(this.params.percentageuserlimitmessage, { actionLabel: this.params.visitsupport, href: this.params.supportlink });
      localStorage.removeItem("USER_LIMIT_FLAG_80");
    }

    // Check for the flag that defines that 100 percent of the user limit has been reached
    if (localStorage.getItem("USER_LIMIT_FLAG")) {
      _collow.Notify.error(this.params.maxuserlimitmessage, { actionLabel: this.params.visitsupport, href: this.params.supportlink, size: "large" });
      localStorage.removeItem("USER_LIMIT_FLAG");
    }
  };

  checkUserLimitExceeded = async (event) => {
    // Build in a delay for _collow.Notify to initialize
    window.addEventListener("load", this.checkUserLimitFlags);
  };

  /**
  * Enables buttons after users have been loaded.
  */
  enableButtons = () => {
    document.querySelector('[data-admin-control-users\\:add-user]').removeAttribute('disabled');
    document.querySelector('[data-admin-control-users\\:import]').removeAttribute('disabled');
  };
};